import { useFriendsListContainer } from "./FriendsListContainer.hook";
import PageWrapper from "../../common/components/PageWrapper";
import Table from "../../common/components/Table";
import UserAvatar from "../../common/components/UserAvatar";

export default function FriendsListContainer() {
  const {
    models: { loading, isFetchingMore, pageInfo, data },
    operations: { onViewChange },
  } = useFriendsListContainer();

  return (
    <PageWrapper>
      <Table.Wrapper>
        <Table.Header
          tabs={[
            { label: "사진" },
            { label: "이름" },
            { label: "닉네임" },
            { label: "쇼핑몰 연동여부" },
            { label: "댓글 수" },
            { label: "돌봄기록 수" },
            { label: "게시물 수" },
          ]}
        />
        <Table.Body
          isLoading={loading}
          isEmpty={!data?.length}
          emptyMessage="아직 초대한 친구가 없습니다!"
          infiniteScroll={{
            hasNextPage: pageInfo?.hasNextPage || false,
            isFetchingMore,
            onViewChange,
          }}
        >
          {data?.map((friendData) => {
            const friend = friendData?.invitedCaregiver;

            return (
              <Table.Row>
                <Table.Column>
                  <UserAvatar
                    src={
                      friend?.avatar?.uri || "/images/default_user_image.png"
                    }
                    alt="친구 사진"
                    size={50}
                  />
                </Table.Column>
                <Table.Column>{friend?.name}</Table.Column>
                <Table.Column>{friend?.username}</Table.Column>
                <Table.Column>
                  {!!friend?.cafe24MemberId ? "Y" : "N"}
                </Table.Column>
                <Table.Column>{friend?.replyCount}개</Table.Column>
                <Table.Column>{friend?.dailyReportCount}개</Table.Column>
                <Table.Column>{friend?.communityCount}개</Table.Column>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table.Wrapper>
    </PageWrapper>
  );
}
